/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Button, Card, CardHeader, Container, Row, Spinner } from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import { removeWidgetItem } from "consts/Constants";
import Swal from "sweetalert2";
import AddEditAnnouncementModal from "./AddEditAnnouncementModal";

const { SearchBar } = Search;

export default function Announcements(props) {
  const [loading, setLoading] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [data, setData] = useState([]);
  const [currentModel, setCurrenModel] = useState({});

  const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  });

  const getItems = () => {
    setLoading(true);
    axiosConfig
      .get("admin/announcements")
      .then((res) => {
        setLoading(false);

        setData(res.data.result.announcements);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const removeItem = (id) => {
    removeWidgetItem("admin/announcements/delete/" + id, getItems);
  };
  useEffect(() => {
    getItems();
  }, []);
  const newItemModal = () => {
    setCurrenModel({});
    setShowAddEditModal(true);
  };
  return (
    <>
      <ListHeader
        name="Announcements"
        parentName="Dashboard"
        setShowModal={newItemModal}
        setCurrenModel={setCurrenModel}
      />
      <Container className="mt--6" fluid>
        {showAddEditModal ? (
          <AddEditAnnouncementModal
            showModal={showAddEditModal}
            toggleModal={setShowAddEditModal}
            getItems={getItems}
            currentModel={currentModel}
          />
        ) : (
          <></>
        )}
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Announcements</h3>
              </CardHeader>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "title",
                    text: "Title",
                    sort: true,
                  },
                  {
                    dataField: "short",
                    text: "Body",
                    sort: true,
                  },
                  {
                    dataField: "publish_date",
                    text: "Publish Date",
                    sort: true,
                  },
                  {
                    dataField: "expires_at",
                    text: "Expiration Date",
                    sort: true,
                  },
                  {
                    dataField: "status",
                    text: "Status",
                    sort: true,
                  },
                  {
                    dataField: "views",
                    text: "Views",
                    sort: true,
                  },
                  {
                    dataField: "name",
                    text: "Actions",
                    editable: true,
                    sort: false,
                    formatter: (cell, row) => {
                      return (
                        <>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                              setCurrenModel(row);
                              setShowAddEditModal(true);
                            }}
                          >
                            <i className="fa fa-pen" />
                          </Button>

                          <Button
                            color="danger"
                            size="sm"
                            onClick={() =>
                              Swal.fire({
                                title: "Are you sure?",
                                text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  removeItem(row.id);
                                }
                              })
                            }
                          >
                            <i className="fa fa-trash" />
                          </Button>
                        </>
                      );
                    },
                  },
                ]}
                search
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1"
                    >
                      <label>
                        Search:
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={false}
                      noDataIndication={
                        loading ? (
                          <Spinner color="info" size="xl" />
                        ) : (
                          <div>
                            <p>No Announcements yet!</p>
                            <a
                              className="btn btn-link text-muted font-italic"
                              onClick={() => {
                                setCurrenModel({});
                                setShowAddEditModal(true);
                              }}
                            >
                              Start by adding to your Announcements
                            </a>
                          </div>
                        )
                      }
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
